import { useURLParameters } from 'hooks';
import {
  PositionsAllocationModalViewType,
  PositionsAllocationComponentMap,
} from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.constants';
import { positionsAllocationModalRoutingService } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModalRouting.constants';
import { createContext, FC, useCallback, useContext, useEffect } from 'react';

export interface IPositionsAllocationlUI {
  isOpen: boolean;
  onClose: () => void;
  positionsAllocationActiveModalView: PositionsAllocationModalViewType;
  positionId: string;
}

export const PositionsAllocationViewUIContext = createContext<IPositionsAllocationlUI>(
  {} as IPositionsAllocationlUI,
);

export const PositionsAllocationViewUIProvider: FC = ({ children }) => {
  const [{ positionId, positionsAllocationActiveModalView }, { removeParam }] =
    useURLParameters<{ activeModalView: PositionsAllocationModalViewType }>();

  const handleClose = useCallback(() => {
    positionsAllocationModalRoutingService.close();
  }, []);

  useEffect(() => {
    if (
      !Object.keys(PositionsAllocationComponentMap).includes(positionsAllocationActiveModalView)
    ) {
      removeParam(['positionsAllocationActiveModalView']);
    }
  }, [positionsAllocationActiveModalView, removeParam]);

  return (
    <PositionsAllocationViewUIContext.Provider
      value={{
        isOpen: !!positionsAllocationActiveModalView,
        onClose: handleClose,
        positionsAllocationActiveModalView:
          positionsAllocationActiveModalView as PositionsAllocationModalViewType,
        positionId,
      }}
    >
      {children}
    </PositionsAllocationViewUIContext.Provider>
  );
};

export const usePositionsAllocationModalUIContext = () =>
  useContext<IPositionsAllocationlUI>(PositionsAllocationViewUIContext);
